// Dados dos vídeos, portados literalmente do frontmatter de
// /tmp/astro/src/data/videos/*.md (site Astro). Nenhum arquivo .md tinha
// corpo/transcrição — apenas os campos de frontmatter abaixo.

export type Video = {
  youtubeId: string;
  titulo: string;
  pilar: string;
  tratamento: string;
  duracao: string;
  views: number;
  viewsRotulo: string;
  ordem: number;
};

export const VIDEOS: readonly Video[] = [
  {
    youtubeId: "xnNj3lFP-60",
    titulo: "A comparação está destruindo sua paz (e você nem percebe)",
    pilar: "Saúde emocional",
    tratamento: "/tratamentos/longevidade/",
    duracao: "16:23",
    views: 3200,
    viewsRotulo: "3,2 mil visualizações",
    ordem: 3,
  },
  {
    youtubeId: "T85_A8acmpY",
    titulo: "Por que a beterraba é tão importante no pré-treino?",
    pilar: "Exercício e músculo",
    tratamento: "/tratamentos/massa-muscular/",
    duracao: "13:36",
    views: 1700,
    viewsRotulo: "1,7 mil visualizações",
    ordem: 24,
  },
  {
    youtubeId: "HHCUT619MqQ",
    titulo: "CANETA EMAGRECEDORA FALSA: Os riscos para sua saúde",
    pilar: "Metabólico-hormonal",
    tratamento: "/tratamentos/emagrecimento/",
    duracao: "10:42",
    views: 12000,
    viewsRotulo: "12 mil visualizações",
    ordem: 9,
  },
  {
    youtubeId: "4QFQRbKw2pA",
    titulo: "Dormir ajuda a emagrecer e ganhar massa muscular?",
    pilar: "Sono",
    tratamento: "/tratamentos/longevidade/",
    duracao: "12:26",
    views: 14000,
    viewsRotulo: "14 mil visualizações",
    ordem: 11,
  },
  {
    youtubeId: "__qBbI6lYWs",
    titulo: "Você Está Envelhecendo Bem ou Só Ficando Mais Velho?",
    pilar: "Propósito",
    tratamento: "/saude-com-proposito/",
    duracao: "11:55",
    views: 316,
    viewsRotulo: "316 visualizações",
    ordem: 0,
  },
  {
    youtubeId: "1rzU9s993YY",
    titulo: "Esses hábitos estão matando você!",
    pilar: "Saúde emocional",
    tratamento: "/tratamentos/longevidade/",
    duracao: "10:05",
    views: 5500,
    viewsRotulo: "5,5 mil visualizações",
    ordem: 29,
  },
  {
    youtubeId: "3gPZDhSHdYE",
    titulo: "Exercite seu intestino!",
    pilar: "Alimentação",
    tratamento: "/tratamentos/emagrecimento/",
    duracao: "13:53",
    views: 2200,
    viewsRotulo: "2,2 mil visualizações",
    ordem: 27,
  },
  {
    youtubeId: "PLPLU_77dnE",
    titulo: "Família Saudável: como criar hábitos que duram para sempre.",
    pilar: "Propósito",
    tratamento: "/saude-com-proposito/",
    duracao: "23:11",
    views: 14000,
    viewsRotulo: "14 mil visualizações",
    ordem: 18,
  },
  {
    youtubeId: "-ts53xjmSfU",
    titulo: "Por que você DEVE focar em ganhar músculos (principalmente depois dos 40)",
    pilar: "Exercício e músculo",
    tratamento: "/tratamentos/massa-muscular/",
    duracao: "20:29",
    views: 4400,
    viewsRotulo: "4,4 mil visualizações",
    ordem: 5,
  },
  {
    youtubeId: "QtK97bStJJA",
    titulo: "Dá para ganhar massa muscular emagrecendo?",
    pilar: "Exercício e músculo",
    tratamento: "/tratamentos/massa-muscular/",
    duracao: "17:05",
    views: 12000,
    viewsRotulo: "12 mil visualizações",
    ordem: 12,
  },
  {
    youtubeId: "uwBPqQjX34E",
    titulo: "Como o hábito de reclamar afeta a sua saúde mental",
    pilar: "Saúde emocional",
    tratamento: "/tratamentos/longevidade/",
    duracao: "9:30",
    views: 5500,
    viewsRotulo: "5,5 mil visualizações",
    ordem: 23,
  },
  {
    youtubeId: "HPbyrnSL9uU",
    titulo: "Hábitos de Quem Emagreceu e NUNCA Mais Engordou",
    pilar: "Metabólico-hormonal",
    tratamento: "/tratamentos/emagrecimento/",
    duracao: "17:00",
    views: 51000,
    viewsRotulo: "51 mil visualizações",
    ordem: 7,
  },
  {
    youtubeId: "rj2r19N8A4k",
    titulo: "A Influência do Ambiente na Sua Saúde Mental",
    pilar: "Saúde emocional",
    tratamento: "/tratamentos/longevidade/",
    duracao: "18:34",
    views: 5700,
    viewsRotulo: "5,7 mil visualizações",
    ordem: 2,
  },
  {
    youtubeId: "9ESdhMKZDEA",
    titulo: "Jejum intermitente atrapalha ganho de massa muscular?",
    pilar: "Exercício e músculo",
    tratamento: "/tratamentos/massa-muscular/",
    duracao: "15:50",
    views: 9500,
    viewsRotulo: "9,5 mil visualizações",
    ordem: 13,
  },
  {
    youtubeId: "dmq8GpTtgfY",
    titulo: "Jejum Intermitente: O que a insulina, a leptina e a grelina estão te dizendo?",
    pilar: "Alimentação",
    tratamento: "/tratamentos/emagrecimento/",
    duracao: "20:22",
    views: 21000,
    viewsRotulo: "21 mil visualizações",
    ordem: 14,
  },
  {
    youtubeId: "cC-rONZSLCA",
    titulo: "O que nunca te contaram sobre o jejum intermitente",
    pilar: "Alimentação",
    tratamento: "/tratamentos/emagrecimento/",
    duracao: "9:29",
    views: 18000,
    viewsRotulo: "18 mil visualizações",
    ordem: 25,
  },
  {
    youtubeId: "YUwqrJqEpwM",
    titulo: "Microbioma e emagrecimento: o que ninguém te explicou ainda",
    pilar: "Alimentação",
    tratamento: "/tratamentos/emagrecimento/",
    duracao: "18:57",
    views: 61000,
    viewsRotulo: "61 mil visualizações",
    ordem: 15,
  },
  {
    youtubeId: "fGXgV6fhkm8",
    titulo: "Morango do Amor ou Morango da Saúde?",
    pilar: "Alimentação",
    tratamento: "/tratamentos/emagrecimento/",
    duracao: "8:12",
    views: 9700,
    viewsRotulo: "9,7 mil visualizações",
    ordem: 20,
  },
  {
    youtubeId: "s2q-Hef6CcA",
    titulo: "O final de semana está te prejudicando?",
    pilar: "Saúde emocional",
    tratamento: "/tratamentos/longevidade/",
    duracao: "10:11",
    views: 659,
    viewsRotulo: "659 visualizações",
    ordem: 28,
  },
  {
    youtubeId: "RzjtF3lNXu0",
    titulo: "O que é NAC? (N-acetilcisteína) Para que Serve e Como Funciona",
    pilar: "Suplementação",
    tratamento: "/tratamentos/avaliacao-360/",
    duracao: "13:31",
    views: 55000,
    viewsRotulo: "55 mil visualizações",
    ordem: 8,
  },
  {
    youtubeId: "4_Jf64Pfdgs",
    titulo: "Parei de consumir açúcar e minha vida mudou.",
    pilar: "Alimentação",
    tratamento: "/tratamentos/emagrecimento/",
    duracao: "19:52",
    views: 11000,
    viewsRotulo: "11 mil visualizações",
    ordem: 21,
  },
  {
    youtubeId: "3GN5pH8n5VQ",
    titulo: "O que acontece quando seu amigo se alimenta mal?",
    pilar: "Saúde emocional",
    tratamento: "/tratamentos/longevidade/",
    duracao: "9:26",
    views: 3900,
    viewsRotulo: "3,9 mil visualizações",
    ordem: 26,
  },
  {
    youtubeId: "BK_z1wbBIos",
    titulo: "Quanto mais você emagrece menos você emagrece!",
    pilar: "Metabólico-hormonal",
    tratamento: "/tratamentos/emagrecimento/",
    duracao: "19:39",
    views: 13000,
    viewsRotulo: "13 mil visualizações",
    ordem: 22,
  },
  {
    youtubeId: "YfTGw9qW604",
    titulo: "7 dicas PRÁTICAS para sair do sedentarismo (e levantar do sofá hoje)",
    pilar: "Exercício e músculo",
    tratamento: "/tratamentos/massa-muscular/",
    duracao: "18:01",
    views: 2700,
    viewsRotulo: "2,7 mil visualizações",
    ordem: 4,
  },
  {
    youtubeId: "wGJJ1DQPk3M",
    titulo: "Sono, Cortisol e Gordura Abdominal: o triângulo mortal",
    pilar: "Sono",
    tratamento: "/tratamentos/longevidade/",
    duracao: "21:33",
    views: 24000,
    viewsRotulo: "24 mil visualizações",
    ordem: 16,
  },
  {
    youtubeId: "3rDAHTIeuUQ",
    titulo: "Tudo Sobre as Canetas Emagrecedoras: Vale a Pena?",
    pilar: "Metabólico-hormonal",
    tratamento: "/tratamentos/emagrecimento/",
    duracao: "19:07",
    views: 15000,
    viewsRotulo: "15 mil visualizações",
    ordem: 10,
  },
  {
    youtubeId: "3pnyMpSkdLs",
    titulo: "Você Já Sabe o Que Fazer. Então Por Que Não Faz?",
    pilar: "Propósito",
    tratamento: "/saude-com-proposito/",
    duracao: "20:30",
    views: 6000,
    viewsRotulo: "6 mil visualizações",
    ordem: 1,
  },
];
